import {useContext, useEffect, useRef, useState} from 'react';
import {LazyLoadContext} from './LazyLoadContext';

export function useLazyLoadIntersection<T extends HTMLDivElement>() {
  const ref = useRef<T>(null);
  const {disabled, addLazyLoad, removeLazyLoad} = useContext(LazyLoadContext);
  const [isIntersection, setIsIntersection] = useState(disabled);

  // 컴포넌트가 마운트 되면 lazyLoad 옵저버에 추가한다.
  useEffect(() => {
    const el = ref.current;
    if (disabled || !el) return;

    addLazyLoad({
      el,
      onIntersection: isIntersecting => {
        isIntersecting && setIsIntersection(true);
      },
    });
  }, [disabled, addLazyLoad]);

  // 뷰포트에 교차되면 등록된 lazyLoad 옵저버 제거.
  useEffect(() => {
    const el = ref.current;
    if (disabled || !isIntersection || !el) return;

    removeLazyLoad(el);
  }, [disabled, removeLazyLoad, isIntersection]);

  return {ref, isIntersection};
}
